
import React from 'react';
import { Button } from "@/components/ui/button";
import { Trash2, Loader2 } from "lucide-react";
import { Company } from "@/types/company";

interface CompanyDialogActionsProps {
  company?: Company;
  isSubmitting: boolean;
  onDelete: () => void;
  onCancel: () => void;
}

export const CompanyDialogActions = ({ company, isSubmitting, onDelete, onCancel }: CompanyDialogActionsProps) => {
  return (
    <div className="flex justify-between gap-2">
      {company && (
        <Button
          type="button"
          variant="destructive"
          onClick={onDelete}
          className="gap-2"
        >
          <Trash2 className="w-4 h-4" />
          حذف
        </Button>
      )}
      <div className="flex gap-2 mr-auto">
        <Button type="button" variant="outline" onClick={onCancel}>
          إلغاء
        </Button>
        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting && <Loader2 className="w-4 h-4 animate-spin ml-2" />}
          {company ? "تحديث" : "إضافة"}
        </Button>
      </div>
    </div>
  );
};
